export default "__VITE_ASSET__2f3262c1__"